import { render, staticRenderFns } from "./UserRideTypeWaitTimePanel.vue?vue&type=template&id=788853ea&scoped=true&"
import script from "./UserRideTypeWaitTimePanel.vue?vue&type=script&lang=js&"
export * from "./UserRideTypeWaitTimePanel.vue?vue&type=script&lang=js&"
import style0 from "./UserRideTypeWaitTimePanel.vue?vue&type=style&index=0&id=788853ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788853ea",
  null
  
)

export default component.exports